/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect } from 'react';
import {
  Flex,
  LinkBox,
  LinkOverlay,
  Button,
  Stack,
  Icon as ChakraIcon,
} from '@chakra-ui/react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { Icon } from 'rsuite';
import styled from 'styled-components';
import { Episode, EpisodeSection } from '../../../@types';
import * as Constants from '../../../constants';
import { EpisodePartsNav } from './EpisodePartsNav';

const EndScreenWrapper = styled.div`
  position: absolute;
  z-index: 200;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  left: 0;
  right: 0;
  background: linear-gradient(45deg, #114e61, #000000ad);
  font-family: var(--font-family-alt);
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  transition: transform 0.3s ease-in-out, opacity 0.4s, visibility 0s;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(1000px);
  .end-screen-inner {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    /* transition: transform 0.3s ease-in-out, opacity 0.4s, visibility 0s; */
    /* opacity: 0;
        visibility: hidden;
        transform: translateY(200px); */
    header {
      opacity: 0;
      transition: opacity 0.4s, transform 0.3s;
      transition-delay: 0.7s;
      transform: translateY(100px);
    }
    main .box-wrapper {
      opacity: 0;
      transition: opacity 0.4s, transform 0.3s;
      transform: translateY(100px) scale(0.5);
    }

    &.is-visible {
      opacity: 1;
      visibility: visible;
      transform: translateY(0) scale(1);
      header,
      main .box-wrapper {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
  &.show {
    transform: translateX(0);
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
  header,
  main {
    flex-basis: 100%;
  }
  header {
    padding: 40px 0;
    color: #fff;
    flex: 0;
    h2 {
      text-align: center;
      font-family: 'Londrina Solid', sans-serif;
      font-size: 3rem;
      letter-spacing: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px dashed;
      padding-bottom: 30px;

      i {
        font-size: 50px;
        margin-right: 20px;
        background: #18bd18;
        border-radius: 50%;
      }
    }
    p {
      font-size: 1.1rem;
      padding: 20px 0 0;
      text-align: center;
      font-weight: 300;
      line-height: 1.7;
    }
  }
  main {
    /* flex-grow: 1; */
    width: 85%;
    margin: 0 auto;
    height: calc(100% - 250px);
    flex-basis: auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .box-wrapper {
      width: calc(50% - 25px);
      height: calc(50% - 25px);
      flex-grow: 1;
      margin: 12px;
    }
    section {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      position: relative;
      cursor: pointer;
      transform: scale(1);
      transition: transform 0.2s, opacity 0.4s, box-shadow 0.2s;
      opacity: 0.8;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      z-index: 6;
      box-shadow: 1px 1px 30px #00000024;
      border-radius: 12px;
      overflow: hidden;

      h3 {
        color: #fff;
        position: relative;
        z-index: 6;
        top: 50%;
        transform: translateY(-50%);
        font-weight: 200;
        font-size: 2rem;
        padding: 12px 40px;
        border-radius: 50px;
        border: 2px solid #fff0;
        transition: 0.2s;
        background: rgba(0, 0, 0, 0);
        letter-spacing: -0.5px;
      }

      .box-overlay {
        position: absolute;
        left: 0;
        right: 0;

        background-image: linear-gradient(to top, black, rgba(0, 0, 0, 0.5));
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: 0 0;
        bottom: 0;
        top: 0;
        pointer-events: none;
        transition: all 0.25s ease;
        z-index: 5;
      }
      &:hover {
        z-index: 8;
        box-shadow: 1px 1px 30px #000;
        opacity: 1;

        h3 {
          top: 95%;
          transform: translateY(-100%);
        }

        .box-overlay {
          top: calc(100% - 100px);
        }
      }
    }
  }
`;
export const EpisodeEndScreen: React.FC<{
  show: boolean;
  hide: () => void;
  nextEpisode: Episode | null;
  sections: EpisodeSection[];
  currentSectionIdx: number;
}> = ({ show, hide, nextEpisode, sections = [], currentSectionIdx }) => {
  const [isVisible, setIsVisible] = React.useState(false);
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        setIsVisible(true);
      }, 200);
    }
  }, [show]);

  return (
    <EndScreenWrapper className={`${show ? 'show' : ''}`}>
      <div className={`end-screen-inner ${isVisible ? 'is-visible' : ''}`}>
        <Flex w="full" justify="flex-end">
          <Button
            bg="transparent"
            color="white"
            opacity={0.7}
            m={4}
            _hover={{ bg: 'gray.500' }}
            onClick={() => hide()}
          >
            <Icon size="2x" icon="close" />
          </Button>
        </Flex>

        <header>
          <h2>
            <Icon icon="check-circle" />
            Episode Completed
          </h2>
          <p>
            Nice job! You completed{' '}
            {(sections?.length || 0) > 1
              ? `part ${currentSectionIdx + 1} of`
              : ''}{' '}
            the episode!
            <br />
          </p>
          {!!sections?.length && currentSectionIdx >= 0 && (
            <EpisodePartsNav
              sections={sections}
              currentSectionIdx={currentSectionIdx}
              hideEndScreenOnNavigate={() => hide()}
              isCompleted
            />
          )}
        </header>

        <main>
          <Stack spacing={10}>
            {nextEpisode && (
              <LinkBox display="inline-block">
                <LinkOverlay
                  _hover={{ textDecoration: 'none' }}
                  href={`/player/${nextEpisode.id}?part=1`}
                >
                  <Button
                    colorScheme="green"
                    variant="solid"
                    size="lg"
                    minW="300px"
                    rightIcon={<ChakraIcon boxSize={5} as={FiArrowRight} />}
                  >
                    Next Episode
                  </Button>
                </LinkOverlay>
              </LinkBox>
            )}
            <LinkBox display="inline-block">
              <LinkOverlay
                _hover={{ textDecoration: 'none' }}
                href={`${Constants.ROOT_URL}`}
              >
                <Button
                  colorScheme="primary"
                  variant="solid"
                  size="lg"
                  minW="300px"
                  leftIcon={<ChakraIcon boxSize={5} as={FiArrowLeft} />}
                >
                  Back to Library
                </Button>
              </LinkOverlay>
            </LinkBox>
          </Stack>
        </main>
      </div>
    </EndScreenWrapper>
  );
};
